// redex/users/userApi.js
import api from "../../utils/api";
import { apiPath } from "../../utils/apiPath";
import { showApiErrorToast } from "../../utils/toastErrorHandler";



// POST Create API
export async function createUserApi(payload) {
  try {
    const response = await api.post(
      apiPath.users.createUser,
      payload, // Send payload directly as the body
      { headers: { "Content-Type": "application/json" } },
    );
    return response.data;
  } catch (error) {
    console.error("Create Task Error:", error);
    throw showApiErrorToast(error.response?.data);
  }
}


// export async function usersListApi(payload) {
//   // Use .get() if you are just fetching a list. Use .post() only if sending filter criteria.
//   return await api.get(
//     `${apiPath.API_URL}${apiPath.users.getUser}`,
//     { params: payload } // Send payload as query params for GET requests
//   );
// }

export async function usersListApi(payload) {
  const response = await api.get(
    `${apiPath.API_URL}${apiPath.users.getUser}`,
    {
      params: payload,
    }
  );

  return response.data;
}
export async function updatePasswordApi(payload) {
  try {
    const response = await api.put(
      apiPath.users.updatePassword, // Changed from createUser to updatePassword
      payload,
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    console.error("Update Password Error:", error);
    throw showApiErrorToast(error.response?.data);
  }
}



export async function updateUserWorkStatusApi(payload) {
  try {
    // We extract the id to put in the URL, and send the rest (workStatus) in the body
    const { id, ...bodyData } = payload;

    const response = await api.put(
      // Assuming you add this to apiPath: apiPath.users.updateWorkStatus
      // If not, replace apiPath.users.updateWorkStatus with "/api/v1/user/update-user-work-status/"
      `${apiPath.users.updateWorkStatus}/${id}`,
      bodyData,
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    console.error("Update Work Status Error:", error);
    throw showApiErrorToast(error.response?.data);
  }
}